export default __webpack_public_path__ + "static/media/quiz.d5372e64.PNG";